// extracted by mini-css-extract-plugin
export default {"verificationCodeInput":"LoginPageVerificationCode_verificationCodeInput__0EZI7"};